import CustomerSelect from 'App/Vehicles/shared/CustomerSelect';
import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import { UserFormSchema } from 'core/schemas/userForm';

export default function UserCustomer() {
  const { setFieldValue, values } = useFormikContext<UserFormSchema>();
  const { customer_id, role_id } = values.user;

  useEffect(() => {
    // Reset the user.customer_id when role changes something else
    if (
      !(role_id === 'customer' || role_id === 'customer-employee') &&
      customer_id
    ) {
      setFieldValue('user.customer_id' as any, null);
    }
  }, [customer_id, role_id, setFieldValue]);

  if (!(role_id === 'customer' || role_id === 'customer-employee')) {
    return null;
  }

  return <CustomerSelect name="user.customer_id" required />;
}
